import {
    INICIA_ATIVIDADE_PEDAGOGICA,
    INICIO_ATIVIDADE_PEDAGOGICA_SUCESSO,
    LISTA_ATIVIDADE_PEDAGOGICA,
    LISTA_ATIVIDADE_PEDAGOGICA_SUCESSO,
    SALVA_ATIVIDADE_PEDAGOGICA,
    SALVA_ATIVIDADE_PEDAGOGICA_SUCESSO,
    REMOVE_ATIVIDADE_PEDAGOGICA,
    REMOVE_ATIVIDADE_PEDAGOGICA_SUCESSO,
    BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO,
    BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO_SUCESSO,
    NOVA_ATIVIDADE_PEDAGOGICA,
    ATUALIZA_ATIVIDADE_PEDAGOGICA,
    LIMPAR_ATIVIDADE_PEDAGOGICA,
    LISTA_TURMAS_PARA_ATIVIDADE,
    LISTA_TURMAS_PARA_ATIVIDADE_SUCESSO,
    LISTA_ESCOLAS_ATIVIDADE,
    LISTA_ESCOLAS_ATIVIDADE_SUCESSO,
    LISTA_CURSOS_ATIVIDADE,
    LISTA_CURSOS_ATIVIDADE_SUCESSO,
    LISTA_SERIES_ATIVIDADE,
    LISTA_SERIES_ATIVIDADE_SUCESSO,
    LISTA_ETAPAS_ATIVIDADE,
    LISTA_ETAPAS_ATIVIDADE_SUCESSO,
    LISTA_DISCIPLINAS_ATIVIDADE,
    LISTA_DISCIPLINAS_ATIVIDADE_SUCESSO,
    LISTA_ALUNOS_TURMA_ATIVIDADE,
    LISTA_ALUNOS_TURMA_ATIVIDADE_SUCESSO,
    LIMPAR_FILTROS_ATIVIDADE,
    NOVA_ATIVIDADE_PEDAGOGICA_LOTE,
    SALVA_ATIVIDADE_PEDAGOGICA_LOTE,
    SALVA_ATIVIDADE_PEDAGOGICA_LOTE_SUCESSO,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SHOW_MESSAGE_SUCCESS,
    SHOW_MESSAGE_ERROR,
    HIDE_MESSAGE
} from 'constants/ActionTypes';
import moment from 'moment';

const safeId = (v) => {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return isNaN(n) ? v : n;
};

const normalizeEscolaItem = (e) => ({
    id: safeId(e.id || e.Id),
    title: e.nome || e.Nome || String(e.id || e.Id || '')
});

const normalizeCursoItem = (c) => {
    const id = safeId(c.id || c.Id || c.cursoId || c.CursoId);
    const nome = c.cursoNome || c.Nome || c.descricao || c.Descricao || c.titulo || c.Titulo || String(id || '');
    return { id, title: nome };
};

const normalizeSerieItem = (s) => {
    const id = safeId(s.id || s.Id || s.serieId || s.SerieId);
    const nome = s.nome || s.Nome || s.descricao || s.Descricao || s.titulo || s.Titulo || String(id || '');
    return { id, title: nome };
};

const normalizeTurmaItem = (t) => {
    const id = safeId(t.id || t.Id);
    const nome = t.nome || t.Nome || t.descricao || t.Descricao || String(id || '');
    return { id, title: nome };
};

const normalizeEtapaItem = (e) => {
    const id = safeId(e.periodoAnoLetivoId || e.PeriodoAnoLetivoId || e.etapaId || e.EtapaId || e.id || e.Id);
    const nome = e.etapaNome || e.nome || e.Nome || e.descricao || e.Descricao || e.titulo || e.Titulo || String(id || '');
    return { id, title: nome };
};

const normalizeDisciplinaItem = (d) => {
    const id = safeId(d.componenteEscolaId || d.ComponenteEscolaId || d.disciplinaId || d.DisciplinaId || d.componenteCurricularId || d.id || d.Id);
    const nome = d.disciplinaNome || d.nome || d.Nome || (d.disciplina && d.disciplina.nome) || d.componenteCurricularNome || String(id || '');
    return { id, title: nome };
};

const INIT_STATE = {
    loader: false,
    loaderExcluir: false,
    alertMessage: '',
    showMessage: false,
    showMessageSuccess: false,
    showMessageError: false,
    edicao: false,

    // Lista
    listaAtividades: [],

    // Formulario
    id: 0,
    titulo: '',
    descricao: '',
    dataCriacao: '',
    dataEntrega: '',
    horaEntrega: '',
    valeNota: false,
    componenteEscolaId: null,
    professorId: null, // Geralmente pego do contexto, mas pode estar aqui
    arquivos: [],

    // Controle de UI para Objetivos
    tipoAtribuicao: 'TURMA', // 'TURMA' | 'ALUNO'
    turmaSelecionadaId: null,
    objetivos: [], // Array final

    // Filtros Cascata
    filtroAnoLetivo: '',
    filtroEscolaId: null,
    filtroCursoId: null,
    filtroSerieId: null,
    filtroEtapaId: null,
    filtroDisciplinaId: null,
    filtroTurmaId: null,
    tipoAtividadePedagogicaId: null,

    // Listas Auxiliares
    listaTurmas: [],
    listaEscolas: [],
    listaCursos: [],
    listaSeries: [],
    listaEtapas: [],
    listaDisciplinas: [],
    listaAlunos: [],
    alunosSelecionados: [], // IDs dos alunos selecionados
    modoLote: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        // --- Filtros Cascata e Limpeza de Dependentes ---
        case LISTA_ESCOLAS_ATIVIDADE: {
            if (state.edicao) {
                return {
                    ...state,
                    listaEscolas: []
                };
            }
            return {
                ...state,
                // Limpa tudo abaixo de escola
                listaEscolas: [],
                filtroEscolaId: null,
                filtroCursoId: null,
                filtroSerieId: null,
                filtroEtapaId: null,
                filtroDisciplinaId: null,
                filtroTurmaId: null,
                listaCursos: [],
                listaSeries: [],
                listaEtapas: [],
                listaDisciplinas: []
            };
        }
        case LISTA_ESCOLAS_ATIVIDADE_SUCESSO: {
            const escolasRaw = action.payload || [];
            const listaEscolas = Array.isArray(escolasRaw) ? escolasRaw.map(normalizeEscolaItem) : [];
            return {
                ...state,
                listaEscolas
            };
        }

        case LISTA_CURSOS_ATIVIDADE: {
            const { manterSelecao } = action.payload || {};
            return {
                ...state,
                filtroEscolaId: action.payload.escolaId,
                filtroAnoLetivo: action.payload.anoLetivo,
                // Limpa dependentes (Curso, Serie, Etapa, Disciplina) SE não for para manter seleção
                filtroCursoId: manterSelecao ? state.filtroCursoId : null,
                filtroSerieId: manterSelecao ? state.filtroSerieId : null,
                filtroEtapaId: manterSelecao ? state.filtroEtapaId : null,
                filtroDisciplinaId: manterSelecao ? state.filtroDisciplinaId : null,
                filtroTurmaId: manterSelecao ? state.filtroTurmaId : null,
                listaCursos: [],
                listaSeries: manterSelecao ? state.listaSeries : [],
                listaEtapas: manterSelecao ? state.listaEtapas : [],
                listaDisciplinas: manterSelecao ? state.listaDisciplinas : []
            };
        }
        case LISTA_CURSOS_ATIVIDADE_SUCESSO: {
            const cursosRaw = action.payload || [];
            const listaCursos = Array.isArray(cursosRaw) ? cursosRaw.map(normalizeCursoItem) : [];
            return {
                ...state,
                listaCursos
            };
        }

        case LISTA_SERIES_ATIVIDADE: {
            const { manterSelecao } = action.payload || {};
            return {
                ...state,
                filtroCursoId: action.payload.cursoId,
                // Limpa dependentes (Serie, Disciplina) SE não for para manter seleção
                filtroSerieId: manterSelecao ? state.filtroSerieId : null,
                filtroDisciplinaId: manterSelecao ? state.filtroDisciplinaId : null,
                filtroTurmaId: manterSelecao ? state.filtroTurmaId : null,
                listaSeries: [],
                listaDisciplinas: manterSelecao ? state.listaDisciplinas : []
            };
        }
        case LISTA_SERIES_ATIVIDADE_SUCESSO: {
            const seriesRaw = action.payload || [];
            const listaSeries = Array.isArray(seriesRaw) ? seriesRaw.map(normalizeSerieItem) : [];
            return {
                ...state,
                listaSeries
            };
        }

        case LISTA_ETAPAS_ATIVIDADE: {
            const { manterSelecao } = action.payload || {};
            return {
                ...state,
                // Etapas dependem de Escola/Ano, mas geralmente são carregadas junto ou em paralelo
                // Se recarregar etapas, reseta a seleção de etapa SE não for para manter seleção
                filtroEtapaId: manterSelecao ? state.filtroEtapaId : null,
                listaEtapas: []
            };
        }
        case LISTA_ETAPAS_ATIVIDADE_SUCESSO: {
            const etapasRaw = action.payload || [];
            const listaEtapas = Array.isArray(etapasRaw) ? etapasRaw.map(normalizeEtapaItem) : [];
            return {
                ...state,
                listaEtapas
            };
        }

        case LISTA_DISCIPLINAS_ATIVIDADE: {
            const { manterSelecao } = action.payload || {};
            return {
                ...state,
                filtroSerieId: action.payload.serieId, // Confirma serie
                // Limpa dependentes SE não for para manter seleção
                filtroDisciplinaId: manterSelecao ? state.filtroDisciplinaId : null,
                listaDisciplinas: []
            };
        }
        case LISTA_DISCIPLINAS_ATIVIDADE_SUCESSO: {
            const disciplinasRaw = action.payload || [];
            const listaDisciplinas = Array.isArray(disciplinasRaw) ? disciplinasRaw.map(normalizeDisciplinaItem) : [];

            const ids = listaDisciplinas.map((x) => x && x.id).map(String);
            const currentId = state.filtroDisciplinaId;
            const fallbackId = state.componenteEscolaId;
            const currentExists = currentId !== null && currentId !== undefined && ids.includes(String(currentId));
            const fallbackExists = fallbackId !== null && fallbackId !== undefined && ids.includes(String(fallbackId));

            let filtroDisciplinaId = state.filtroDisciplinaId;
            if (!currentExists) {
                if (fallbackExists) {
                    filtroDisciplinaId = fallbackId;
                } else if (fallbackId !== null && fallbackId !== undefined) {
                    const match = Array.isArray(disciplinasRaw)
                        ? disciplinasRaw.find((d) => {
                            const v = safeId(
                                (d && (d.disciplinaId || d.DisciplinaId || d.componenteEscolaId || d.ComponenteEscolaId || d.componenteCurricularId || d.id || d.Id)) ||
                                (d && d.disciplina && (d.disciplina.id || d.disciplina.Id || d.disciplina.disciplinaId))
                            );
                            return String(v) === String(fallbackId);
                        })
                        : null;
                    if (match) {
                        filtroDisciplinaId = normalizeDisciplinaItem(match).id;
                    }
                }
            }

            return {
                ...state,
                filtroDisciplinaId,
                listaDisciplinas
            };
        }
        case LISTA_ALUNOS_TURMA_ATIVIDADE: {
            const { manterSelecao } = action.payload || {};
            return {
                ...state,
                // Limpa lista anterior
                listaAlunos: [],
                alunosSelecionados: manterSelecao ? state.alunosSelecionados : [],
                // Flag temporária para indicar ao sucesso que deve tentar preservar a seleção
                loadingAlunosManterSelecao: manterSelecao
            };
        }
        case LISTA_ALUNOS_TURMA_ATIVIDADE_SUCESSO: {
            const alunosRaw = action.payload || [];
            // Normalizar se necessário, mas payload já vem com Id, AlunoNome, Foto, Situacao
            // Vamos assumir que Id é a matrícula
            const listaAlunos = alunosRaw;

            let alunosSelecionados = [];

            if (state.loadingAlunosManterSelecao && state.edicao) {
                // Modo Edição: Preservar seleção existente se possível
                if (state.alunosSelecionados && state.alunosSelecionados.length > 0) {
                    // Cenário: Atividade Individual (Tipo 2) com alunos já definidos
                    // Validamos se os alunos selecionados existem na nova lista
                    const novosIds = listaAlunos.map(a => String(a.id || a.Id || a.matriculaId));
                    alunosSelecionados = state.alunosSelecionados.filter(id => novosIds.includes(String(id)));

                    // Se após filtrar sobrar algum, mantemos a seleção específica
                    if (alunosSelecionados.length === 0) {
                        // Se não sobrou nenhum (turma mudou drasticamente?), fallback para todos?
                        // Ou mantém vazio? Se era Tipo 2 e não achou ninguém, melhor vazio.
                    }
                } else {
                    // Cenário: Atividade Global (Tipo 1) ou Tipo 2 sem alunos (improvável)
                    // Se veio vazio da edição, assumimos que é "Todos" (padrão UX)
                    alunosSelecionados = listaAlunos.map(a => a.id || a.Id || a.matriculaId);
                }
            } else {
                // Modo Criação ou Troca Manual de Turma: Seleciona Todos
                alunosSelecionados = listaAlunos.map(a => a.id || a.Id || a.matriculaId);
            }

            return {
                ...state,
                listaAlunos,
                alunosSelecionados,
                loadingAlunosManterSelecao: false
            };
        }
        case LIMPAR_FILTROS_ATIVIDADE: {
            return {
                ...state,
                filtroAnoLetivo: '',
                filtroEscolaId: null,
                filtroCursoId: null,
                filtroSerieId: null,
                filtroEtapaId: null,
                filtroDisciplinaId: null,
                filtroTurmaId: null,
                listaEscolas: [],
                listaCursos: [],
                listaSeries: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaAlunos: [],
                alunosSelecionados: []
            };
        }
        case INICIA_ATIVIDADE_PEDAGOGICA: {
            return {
                ...state,
                loader: true,
                edicao: false
            };
        }
        case INICIO_ATIVIDADE_PEDAGOGICA_SUCESSO: {
            return {
                ...state,
                loader: false
            };
        }
        case LISTA_ATIVIDADE_PEDAGOGICA: {
            return {
                ...state,
                loader: true
            };
        }
        case LISTA_ATIVIDADE_PEDAGOGICA_SUCESSO: {
            return {
                ...state,
                loader: false,
                listaAtividades: action.payload
            };
        }
        case NOVA_ATIVIDADE_PEDAGOGICA: {
            return {
                ...state,
                edicao: true,
                modoLote: false,
                id: 0,
                titulo: '',
                descricao: '',
                dataCriacao: new Date().toISOString(),
                dataEntrega: '',
                horaEntrega: '',
                valeNota: false,
                componenteEscolaId: null,
                tipoAtribuicao: 'TURMA',
                turmaSelecionadaId: null,
                objetivos: [],
                alertMessage: '',
                showMessage: false,
                showMessageSuccess: false,
                showMessageError: false,

                // Limpar Filtros ao iniciar novo
                filtroAnoLetivo: '',
                filtroEscolaId: null,
                filtroCursoId: null,
                filtroSerieId: null,
                filtroEtapaId: null,
                filtroDisciplinaId: null,
                filtroTurmaId: null,
                listaCursos: [],
                listaSeries: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaAlunos: [],
                alunosSelecionados: []
            };
        }
        case NOVA_ATIVIDADE_PEDAGOGICA_LOTE: {
            return {
                ...state,
                edicao: true,
                modoLote: true,
                id: 0,
                titulo: '',
                descricao: '',
                dataCriacao: new Date().toISOString(),
                dataEntrega: '',
                horaEntrega: '',
                valeNota: false,
                componenteEscolaId: null,
                tipoAtribuicao: 'TURMA',
                turmaSelecionadaId: null,
                objetivos: [],
                alertMessage: '',
                showMessage: false,
                showMessageSuccess: false,
                showMessageError: false,

                // Limpar Filtros ao iniciar novo
                filtroAnoLetivo: '',
                filtroEscolaId: null,
                filtroCursoId: null,
                filtroSerieId: null,
                filtroEtapaId: null,
                filtroDisciplinaId: null,
                filtroTurmaId: null,
                listaCursos: [],
                listaSeries: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaAlunos: [],
                alunosSelecionados: []
            };
        }
        case ATUALIZA_ATIVIDADE_PEDAGOGICA: {
            return {
                ...state,
                [action.payload.campo]: action.payload.valor
            };
        }
        case BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO: {
            return {
                ...state,
                loader: true
            };
        }
        case BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO_SUCESSO: {
            const atividade = action.payload;

            // Tratamento de Case-sensitivity e campos alternativos
            let periodoAnoLetivoId = safeId(atividade.periodoAnoLetivoId || atividade.PeriodoAnoLetivoId || atividade.etapaId || atividade.EtapaId);

            if (!periodoAnoLetivoId && atividade.etapa) {
                periodoAnoLetivoId = safeId(atividade.etapa.periodoAnoLetivoId || atividade.etapa.PeriodoAnoLetivoId || atividade.etapa.id || atividade.etapa.Id);
            }

            // Prioriza disciplinaId conforme instrução, mas mantém fallback para componenteEscolaId
            let disciplinaIdRaw = safeId(atividade.disciplinaId || atividade.DisciplinaId);

            if (!disciplinaIdRaw && atividade.disciplina) {
                disciplinaIdRaw = safeId(atividade.disciplina.id || atividade.disciplina.Id || atividade.disciplina.disciplinaId);
            }

            const componenteEscolaIdRaw = safeId(atividade.componenteEscolaId || atividade.ComponenteEscolaId);

            const disciplinaIdFinal = disciplinaIdRaw || componenteEscolaIdRaw;

            const escolaId = safeId(atividade.escolaId || atividade.EscolaId);
            const cursoId = safeId(atividade.cursoId || atividade.CursoId);
            const serieId = safeId(atividade.serieId || atividade.SerieId);
            const anoLetivo = atividade.anoLetivo || atividade.AnoLetivo;

            // Lógica para extrair tipoAtribuicao e turmaSelecionadaId
            // Prioridade: turmaId na raiz (novo padrão)
            let tipoAtribuicao = 'TURMA';
            let turmaSelecionadaId = safeId(atividade.turmaId);

            // Fallback para padrão antigo (turmaId dentro de objetivos)
            if (!turmaSelecionadaId && atividade.objetivos && atividade.objetivos.length > 0) {
                const obj = atividade.objetivos[0];
                if (obj.turmaId) {
                    turmaSelecionadaId = safeId(obj.turmaId);
                }
            }

            // Preencher alunos selecionados
            // Se for Tipo 2, pegamos dos objetivos. Se for Tipo 1, a lógica de "selecionar todos"
            // geralmente ocorre no componente após carregar a lista de alunos, ou podemos deixar vazio
            // e o componente trata. Aqui focamos em recuperar a seleção explícita.
            let alunosSelecionados = [];
            if (atividade.objetivos && Array.isArray(atividade.objetivos)) {
                alunosSelecionados = atividade.objetivos
                    .filter(o => o.matriculaId)
                    .map(o => o.matriculaId);
            }

            const parseBackendDateTime = (raw) => {
                if (!raw) return null;
                if (typeof raw !== 'string') {
                    const m = moment(raw);
                    return m.isValid() ? m : null;
                }
                const v = raw.trim();
                if (!v) return null;
                // Trunca fração de segundos para milissegundos (backend pode enviar microssegundos)
                const normalized = v.replace(/\.(\d{3})\d+/, '.$1');
                const m = moment(normalized, moment.ISO_8601, true);
                if (m.isValid()) return m;
                const m2 = moment(normalized);
                return m2.isValid() ? m2 : null;
            };

            // Parse data e hora
            let dataEntrega = atividade.dataEntrega;
            let horaEntrega = '';
            if (dataEntrega) {
                const m = parseBackendDateTime(dataEntrega);
                if (m && m.isValid()) {
                    dataEntrega = m.format('DD/MM/YYYY');
                    horaEntrega = m.format('HH:mm');
                }
            }

            // Extrair Ano Letivo da data de criação se não vier explícito
            let filtroAnoLetivo = anoLetivo;
            if (!filtroAnoLetivo && atividade.dataCriacao) {
                const mCriacao = parseBackendDateTime(atividade.dataCriacao);
                if (mCriacao && mCriacao.isValid()) filtroAnoLetivo = mCriacao.format('YYYY');
            }

            // Normalizar Arquivos (mapear fileName para name)
            const arquivos = (atividade.arquivos || []).map(file => ({
                ...file,
                name: file.fileName || file.name
            }));

            return {
                ...state,
                loader: false,
                edicao: true,
                id: atividade.id,
                titulo: atividade.titulo,
                descricao: atividade.descricao,
                dataCriacao: atividade.dataCriacao,
                dataEntrega,
                horaEntrega,
                valeNota: atividade.valeNota,
                componenteEscolaId: disciplinaIdFinal, // Garante que o payload de salvar tenha o ID
                professorId: atividade.professorId,
                objetivos: atividade.objetivos,
                arquivos: arquivos,
                tipoAtribuicao,
                turmaSelecionadaId,
                alunosSelecionados,

                // Preencher Filtros Cascata
                filtroAnoLetivo: filtroAnoLetivo,
                filtroEscolaId: escolaId,
                filtroCursoId: cursoId,
                filtroSerieId: serieId,
                filtroEtapaId: periodoAnoLetivoId,
                filtroDisciplinaId: disciplinaIdFinal,
                tipoAtividadePedagogicaId: safeId(atividade.tipoAtividadePedagogicaId || atividade.TipoAtividadePedagogicaId)
            };
        }
        case SALVA_ATIVIDADE_PEDAGOGICA: {
            return {
                ...state,
                loader: true
            };
        }
        case SALVA_ATIVIDADE_PEDAGOGICA_SUCESSO: {
            return {
                ...state,
                loader: false,
                edicao: false,

                // Limpar Filtros ao salvar com sucesso
                filtroAnoLetivo: '',
                filtroEscolaId: null,
                filtroCursoId: null,
                filtroSerieId: null,
                filtroEtapaId: null,
                filtroDisciplinaId: null,
                filtroTurmaId: null,
                listaEscolas: [],
                listaCursos: [],
                listaSeries: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaAlunos: [],
                alunosSelecionados: []
            };
        }
        case SALVA_ATIVIDADE_PEDAGOGICA_LOTE: {
            return {
                ...state,
                loader: true
            };
        }
        case SALVA_ATIVIDADE_PEDAGOGICA_LOTE_SUCESSO: {
            return {
                ...state,
                loader: false,
                edicao: false,
                modoLote: false,

                // Limpar Filtros ao salvar lote com sucesso
                filtroAnoLetivo: '',
                filtroEscolaId: null,
                filtroCursoId: null,
                filtroSerieId: null,
                filtroEtapaId: null,
                filtroDisciplinaId: null,
                filtroTurmaId: null,
                listaEscolas: [],
                listaCursos: [],
                listaSeries: [],
                listaEtapas: [],
                listaDisciplinas: [],
                listaAlunos: [],
                alunosSelecionados: []
            };
        }
        case REMOVE_ATIVIDADE_PEDAGOGICA: {
            return {
                ...state,
                loaderExcluir: true
            };
        }
        case REMOVE_ATIVIDADE_PEDAGOGICA_SUCESSO: {
            return {
                ...state,
                loaderExcluir: false,
                edicao: false,
                id: 0,
                listaAtividades: state.listaAtividades.filter(item => item.id !== action.payload)
            };
        }
        case LISTA_TURMAS_PARA_ATIVIDADE: {
            return {
                ...state,
                // loader: true // Opcional, talvez não queira bloquear tudo
            };
        }
        case LISTA_TURMAS_PARA_ATIVIDADE_SUCESSO: {
            const turmasRaw = action.payload || [];
            const listaTurmas = Array.isArray(turmasRaw) ? turmasRaw.map(normalizeTurmaItem) : [];
            return {
                ...state,
                listaTurmas
            };
        }
        case ON_SHOW_LOADER: {
            return {
                ...state,
                loader: true
            };
        }
        case SHOW_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false,
                loaderExcluir: false
            };
        }
        case SHOW_MESSAGE_SUCCESS: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: false,
                showMessageSuccess: true,
                showMessageError: false,
                loader: false,
                loaderExcluir: false
            };
        }
        case SHOW_MESSAGE_ERROR: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: false,
                showMessageSuccess: false,
                showMessageError: true,
                loader: false,
                loaderExcluir: false
            };
        }
        case HIDE_MESSAGE: {
            return {
                ...state,
                showMessage: false,
                showMessageSuccess: false,
                showMessageError: false,
                alertMessage: ''
            };
        }
        case LIMPAR_ATIVIDADE_PEDAGOGICA: {
            return INIT_STATE;
        }
        default:
            return state;
    }
};
